<script setup lang="ts">
import Content from '@desktop/views/Relation/Sports/components/RelationView/Content.vue'

import PitchWithIncidents from '../../../components/Main/PitchWithIncidents/PitchWithIncidents.vue'
import MainSummary from './Main/MainSummary/MainSummary.vue'
</script>

<template>
  <Content>
    <template #main>
      <MainSummary />
      <PitchWithIncidents />
    </template>
  </Content>
</template>
